import { LectioJSUtils } from './../LectioJSUtils';
import { HtmlUtilities } from "./../HtmlUtilities";
import { DomDumper } from '../DomDumper';
import { ILectioPlugin } from './Types';

export class PluginLectioPasteHelper implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectiopastehelper', {
			init: editor => {
				initprivate(editor);
			}
		});
	}
}

const debuglog = false;

function initprivate(editor: CKEDITOR.editor) {

	editor.on('paste', evt => {
		// Parse the HTML string to pseudo-DOM structure.
		const fragment = CKEDITOR.htmlParser.fragment.fromHtml(evt.data.dataValue)
			, writer = new CKEDITOR.htmlParser.basicWriter();


		LectioJSUtils.LogDebug('fragment foer: ', evt.data.dataValue);

		RemoveEmptyHeaderElements(fragment);
		RemoveIdFromHeaderElements(fragment);
		ConvertDoubleBreaks(fragment);
		RemoveInvalidAElements(fragment);
		RemoveGoogleDocsMisleadingBoldElements(fragment);

		fragment.writeHtml(writer);
		evt.data.dataValue = writer.getHtml(false);

		LectioJSUtils.LogDebug('fragment efter: ', evt.data.dataValue);

		// event-handler-prioritet 15, så vi kommer efter ckeditors normale
		// oprydning (prioritet 10).
	}, null, null, 15);

	if (debuglog) {
		editor.on('paste', evt => {
			setTimeout(() => {
				const html = editor.getData();
				const dom = new DOMParser().parseFromString(html, 'text/html');
				const dump = DomDumper.GetElementDump(dom.body, 'HeaderVariantAll');
				console.debug(`dom efter paste:\n${dump}`);

			}, 500);
		}, null, null, 52);
	}

	editor.on('paste', evt => {
		const markupBefore = evt.data.dataTransfer.getData('text/html');
		const markupAfter = PreventNumberedHeadingsFromTurningIntoLists(markupBefore);

		const isEdge = /\bEdge\//.test(navigator.appVersion);
		// STM 33585: Edge (17.x og 18.x) og ckeditor (4.10.1) har det haardt
		// med nedenstaaende setdata:
		// Det udloeser en senere fejl i ckeditors tilgang af noget data i
		// clipboard med fejl
		// 'SCRIPT65535: Unexpected call to method or property access.'.
		// Google antyder at det er en fejlkode fra IE9-tiden, saa vi rammer
		// vist ned i noget gammelt skrammel i edge. Hvis man i debuggeren
		// seatter breakpoint i naervaerende funktion, er der en chance for at
		// fejlen ikke opstaar. Har forsoegt med forskellige
		// eventhandler-prioriteter og setTimeout/setImmediate
		// paa setData-kaldet, uden held.  Oh well, det blot noget oprydning af
		// nummeredede headere, saa vi undlader bare at goere det i Edge.
		// (20181101).
		if (!isEdge)
			evt.data.dataTransfer.setData('text/html', markupAfter);

		LectioJSUtils.LogDebug('fragment foer liste-oprydning: ', markupBefore);
		LectioJSUtils.LogDebug('fragment efter liste-oprydning: ', markupAfter);

		// event-handler-prioritet 0, så vi kommer foer ckeditors tolkning af
		// 'mso-list'-styles.
	}, null, null, 0);
}

function RemoveEmptyHeaderElements(fragment: CKEDITOR.htmlParser.fragment) {
	// H1, H2 eller H3-noder som in-effect er tomme, skal blot
	// konverteres til et tomt <p>-tag, da de ellers dukker op som
	// valgbare sections
	for (const node of fragment.children) {
		if (node instanceof CKEDITOR.htmlParser.element) {
			const el = node;
			if (el.name === 'h1' || el.name === 'h2' || el.name === 'h3') {
				// Word kommer gerne med en masse font-tags, så vi
				// bruger jquery til at pakke html-elementet ind,
				// trækker text() ud og spørger om det er den tomme
				// streng
				if ($(el.getOuterHtml()).text().trim() === "") {
					const newParagraph = new CKEDITOR.htmlParser.element('p', null as any);
					newParagraph.add(new CKEDITOR.htmlParser.text('&nbsp;'));
					node.replaceWith(newParagraph);
				}
			}
		}
	}
}

function RemoveIdFromHeaderElements(fragment: CKEDITOR.htmlParser.fragment) {
	// H1, H2 eller H3-noder som har et id andetsteds fra skal have deres id blanket
	for (const node of fragment.children) {
		if (node instanceof CKEDITOR.htmlParser.element) {
			const el = node;
			if (el.name === 'h1' || el.name === 'h2' || el.name === 'h3') {
				// Ved copy-paste fra andre sider kan der komme id med på overskrifter. E.g. hvis man kopierer følgende overskrifter på en gang fra https://seti.ucla.edu/jlm/epo/gravity.html:
				// How realistic is 'Gravity' ?
				// Jean - Luc Margot(2013 Sep 28)
				//
				// Her har første overskrift id'et "interior-split-page-header-full", som kopieres med og overskriver de id'er der bruges i Lectio.
				const id = el.attributes["id"];
				if (id != null && id != undefined && id != "") {
					el.attributes["id"] = null;
				}
			}
		}
	}
}

function RemoveInvalidAElements(fragment: CKEDITOR.htmlParser.fragment) {
	function processNodes(nodes: CKEDITOR.htmlParser.node[], parent: CKEDITOR.htmlParser.element | null) {
		for (let childIx = 0; childIx < nodes.length; childIx++) {
			const node = nodes[childIx];
			if (!(node instanceof CKEDITOR.htmlParser.element))
				continue;
			const el: CKEDITOR.htmlParser.element = node;

			processNodes(el.children, el);

			const isa = el.name === 'a';
			if (!isa)
				continue;

			const href = el.attributes.href;

			const onClick = el.attributes.onclick;
			let onClickOk = true;
			if (onClick) // Hvis der er en onclick attribut
				if (onClick.indexOf('doPostBack') >= 0) //og den indeholder et postback (som fx swup gør)
					onClickOk = false; // så er den ikke ok...

			const isok = ((typeof href === 'string') && !href.match(/^#/)) && onClickOk;
			if (!isok) {
				const countToRemove = el.children.length;
				for (let j = el.children.length - 1; j >= 0; j--) {
					const c = el.children[j];
					c.remove();

					//Hvis vi har med en swupbtn at gøre
					if (c instanceof CKEDITOR.htmlParser.element && c.name === 'img' && c.attributes.id.indexOf('Swup') >= 0) {
						const prnt = el.getAscendant('p');
						if (prnt)
							prnt.remove();
						el.remove();
						continue;
					}

					if (parent)
						parent.add(c, childIx);
					else
						fragment.add(c, childIx);
				}
				childIx += countToRemove;
			}
		}
	}
	processNodes(fragment.children, null);
}

function ConvertDoubleBreaks(fragment: CKEDITOR.htmlParser.fragment) {
	// Tekst-noder med to br-elementer efter er ofte ment som et afsnit.
	// Vi laver saadanne tekstnoder om til afsnit (p-element), for saa
	// kan man bl.a. lave dem om til overskrifter (og lave
	// afsnitsformatering generelt), uden at de følgende linie følger
	// med. Lectio er slem til at have sådan tvivlsom html.
	let hasSeenBrBr = false;
	for (let startChildIndex = 0; startChildIndex < fragment.children.length; startChildIndex++) {
		const c = fragment.children[startChildIndex];
		if (!(c instanceof CKEDITOR.htmlParser.text))
			continue;

		let endChildIndex: number | null = null;
		if (startChildIndex + 2 < fragment.children.length) {
			for (let candidateEndIndex = startChildIndex + 2; candidateEndIndex <= fragment.children.length; candidateEndIndex++) {
				if (candidateEndIndex === fragment.children.length) {
					// Vi er nået til enden uden at bryde ud.
					endChildIndex = candidateEndIndex - 1;
					break;
				}

				const n0 = fragment.children[candidateEndIndex];
				const n1 = fragment.children[candidateEndIndex - 1];
				const isBrBr =
					(n1 instanceof CKEDITOR.htmlParser.element && n1.name === 'br') &&
					(n0 instanceof CKEDITOR.htmlParser.element && n0.name === 'br');
				if (isBrBr) {
					endChildIndex = candidateEndIndex - 2;
					break;
				}
				const areOtherElements =
					(n1 instanceof CKEDITOR.htmlParser.element && n1.name !== 'br') ||
					(n0 instanceof CKEDITOR.htmlParser.element && n0.name !== 'br');
				if (areOtherElements)
					break;
			}
		} else if (startChildIndex + 1 < fragment.children.length) {
			const next = fragment.children[startChildIndex + 1];
			if (!(next instanceof CKEDITOR.htmlParser.element) || next.name !== 'br')
				endChildIndex = startChildIndex + 1;
		} else {
			endChildIndex = startChildIndex;
		}

		if (endChildIndex === null)
			continue;

		// Tager ogsaa foregaaende linieskift-elementer med, hvis der er nogen
		let brBeforeIndex: number | null = null;
		for (let j = startChildIndex; j >= 0 && j >= startChildIndex - 2; j--) {
			const other = fragment.children[j];
			const isBr = other instanceof CKEDITOR.htmlParser.element && other.name === 'br';
			if (isBr)
				brBeforeIndex = j;
		}

		let brAfterIndex: number | null = null;
		for (let j = endChildIndex; j <= fragment.children.length && j <= endChildIndex + 2; j++) {
			const other = fragment.children[j];
			const isBr = other instanceof CKEDITOR.htmlParser.element && other.name === 'br';
			if (isBr)
				brAfterIndex = j;
		}

		const hasSpaceBefore = brBeforeIndex === Math.max(startChildIndex - 2, 0);
		const hasSpaceAfter = brAfterIndex === Math.min(endChildIndex + 2, fragment.children.length);

		hasSeenBrBr = hasSeenBrBr || hasSpaceBefore || hasSpaceAfter;

		if (!hasSeenBrBr)
			continue;

		const replaceStartIndex = hasSpaceBefore ? LectioJSUtils.GetNotNullValue(brBeforeIndex) : startChildIndex;
		const replaceEndIndex = hasSpaceAfter ? LectioJSUtils.GetNotNullValue(brAfterIndex) : endChildIndex;

		const newParagraph = new CKEDITOR.htmlParser.element('p', null as any);
		for (let j = startChildIndex; j <= endChildIndex; j++) {
			newParagraph.add(fragment.children[j]);
		}
		fragment.children[replaceStartIndex] = newParagraph;
		fragment.children.splice(replaceStartIndex + 1, replaceEndIndex - replaceStartIndex);
		startChildIndex = startChildIndex - replaceStartIndex;
	}
}

function RemoveGoogleDocsMisleadingBoldElements(fragment: CKEDITOR.htmlParser.fragment) {
	// html pastet fra fra google docs (20180606) indeholder gerne et b-element
	// med style "font-weight:normal" og et ID med bla. et guid. ckeditor er
	// flink til at erstattet b-elementet med et strong-element, men bevarerer
	// id-attributten.
	// Konsekvensen er at teksten er fed (hvilket den ikke burde vaere/var pga.
	// stylingen) og at man ikke kan fjerne fed-heden, formodentlig fordi
	// ckeditor vaerner om elementer med id-attribut (hvis man i devtools
	// fjerner id-attributten, kan man godt fjerne fedheden).

	function processNodes(nodes: CKEDITOR.htmlParser.node[], parent: CKEDITOR.htmlParser.element | null) {
		for (let childIx = 0; childIx < nodes.length; childIx++) {
			const node = nodes[childIx];
			if (!(node instanceof CKEDITOR.htmlParser.element))
				continue;
			const el: CKEDITOR.htmlParser.element = node;

			processNodes(el.children, el);

			if (el.name !== 'b')
				continue;

			const id: string | undefined = el.attributes.id;
			const isok = !(id && id.match(/^docs-internal-/));
			if (isok)
				continue;

			let countToRemove = 0;
			for (let j = el.children.length - 1; j >= 0; j--) {
				const c = el.children[j];
				c.remove();

				if (parent)
					parent.add(c, childIx);
				else
					fragment.add(c, childIx);
				countToRemove++;
			}
			childIx += countToRemove;

			el.remove();
			childIx--;
		}
	}
	processNodes(fragment.children, null);
}

function PreventNumberedHeadingsFromTurningIntoLists(wordMarkup: string): string {
	// Sometimes Word malforms the comments.
	// (this line is taken from ckeditor 4.8 pastefromword/filter/default.js),
	const markup2 = wordMarkup.replace(/<!\[/g, '<!--[').replace(/\]>/g, ']-->');

	// Parse the HTML string to pseudo-DOM structure.
	const fragment = CKEDITOR.htmlParser.fragment.fromHtml(markup2);

	// ckeditor 4.8: hN-elementer fra worddokumenter der er sat op til
	// at vise headings med nummerering, bliver lavet om til nestede
	// ol/li-elementer.
	// Det er ikke hensigtsmaessigt. Derfor fjerner vi listen-style fra
	// html-en, der ser ca. saaledes ud:
	//   <h2 style='mso-list:l0 level2 lfo1'> ...
	fragment.forEach(n => {
		if (n instanceof CKEDITOR.htmlParser.element) {
			if (n.name === 'h1' || n.name === 'h2' || n.name === 'h3') {
				const style: string | undefined = n.attributes.style;
				if (style) {
					const styles: { [s: string]: string } = CKEDITOR.tools.parseCssText(style);
					delete styles['mso-list'];
					const newStyle = CKEDITOR.tools.writeCssText(styles);
					if (newStyle)
						n.attributes.style = newStyle;
					else
						delete n.attributes.style;
				}
			}
		}

		return true;
	});

	/**
	 * ckeditor 4.8: hN-elementer fra worddokumenter der er sat op til
	 * at vise headings med nummerering, bliver lavet om til nestede
	 * ol/li-elementer.
	 * Se fx. https://drupal.stackexchange.com/questions/251603/is-there-a-way-to-preserve-multi-level-heading-tags-when-pasting-from-ms-word-in
	 * Det er ikke hensigtsmaessigt. Derfor fjerner vi list-style OG
	 * elementerne tilhoerende "if !supportLists" fra html-en, der ser
	 * ca. saaledes ud:
	 *
	 *	<h2 style="mso-list:l0 level2 lfo1">
	 *		<a name="_Toc429984922">
	 *			<!--[if !supportLists]-->
	 *			<span lang="EN-US" style="mso-fareast-font-family:Arial;mso-bidi-font-family:Arial">
	 *				<span style="mso-list:Ignore">1.1 </span>
	 *			</span>
	 *			<!--[endif]-->
	 *			<span lang="EN-US">Why You need Activity Tracking</span>
	 *		</a>
	 *		<span lang="EN-US">
	 *			<o:p/>
	 *		</span>
	 *	</h2>
	 *
	 * Om a-elementer under h2-elementet er der eller ej, varierer.
	 * Sikkert afhaengigt af om dokumentet har en TOC, der linker til
	 * overskriften.
	 *
	 * Hvis word-dokumentet ikke er stylet til at nummerere
	 * overskrifter, er indholdet noget a la flg.:
	 *
	 *	<h2><span lang=EN-US style='mso-ansi-language:EN-US'>Why You need Activity
	 *	Tracking<o:p></o:p></span></h2>
	 *
	 * Et punkt fra en nummereret liste (som vi oensker at lade vaere?)
	 * ser ca. saaledes ud:
	 *
	 *	<p class=MsoListParagraphCxSpFirst style='text-indent:-18.0pt;mso-list:l0 level1 lfo1'>
	 *		<![if !supportLists]>
	 *		<span lang=EN-US style='mso-bidi-font-family:Calibri;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>
	 *			<span style='mso-list:Ignore'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
	 *			</span>
	 *		</span>
	 *		<![endif]>
	 *		<span lang=EN-US style='mso-ansi-language:EN-US'>Punkt 1<o:p/>
	 *		</span>
	 *	</p>
	 *
	 * Ovenstaaende er word 2016 mod chrome 63.
	 */

	const enable = !!((window as any).ppenable ?? true);

	function cleanShit(
		e: CKEDITOR.htmlParser.fragment | CKEDITOR.htmlParser.element,
		ancestors: (CKEDITOR.htmlParser.element | CKEDITOR.htmlParser.fragment)[]
	) {
		let hasFixedParent = false;
		let hasRemovedListComments = false;
		for (let i = 0; i < e.children.length; i++) {
			const child = e.children[i];
			if (child instanceof CKEDITOR.htmlParser.comment && child.value.indexOf("[if !supportLists]") !== -1) {
				if (!(ancestors.length >= 1))
					continue;

				// ok, vi har fundet en af de kommentarnoder, vi leder efter.
				// Find en slutkommentarnode med samme foraelder, haab at de
				// hoerer sammen, og slet indhold fra og med og til og med.

				let endCommentIndex = -1;
				let liststyle: 'ol' | 'ul' | null = null;
				for (let j = i + 1; j < e.children.length; j++) {
					const sibling = e.children[j];
					if (sibling instanceof CKEDITOR.htmlParser.comment && sibling.value.indexOf('[endif]') !== -1) {
						endCommentIndex = j;
						break;
					} else if (sibling instanceof CKEDITOR.htmlParser.element) {
						const writer = new CKEDITOR.htmlParser.basicWriter();
						sibling.writeHtml(writer, null);
						const markup = writer.getHtml(false);
						liststyle = markup.match(/>\s*[\d\w]/) ? 'ol' : 'ul';
					}
				}
				if (endCommentIndex !== -1) {
					e.children.splice(i, (endCommentIndex - i) + 1);
					hasRemovedListComments = true;
				}


				if (!hasFixedParent && hasRemovedListComments) {
					// stm 35253 (20190520), og 35253: Ved paste af ordnet liste bliver forste ord i
					// hvert punkt til tider spist.
					// Jeg (rh) taenker at det skyldes at noget (chrome 74/ckeditor
					// 11.0.(1-4)) fjerner det ud fra en antagelse om at det nok er
					// punktnummeret. Det forsoeger vi her at modvirke ved at saette et
					// nummer ind, som nogen saa kan fjerne igen... Word 2016.
					hasFixedParent = true;
					const stringify = (
						e: CKEDITOR.htmlParser.fragment | CKEDITOR.htmlParser.element,
						buf: string[]
					) => {
						for (let i = 0; i < e.children.length; i++) {
							const child = e.children[i];
							if (child instanceof CKEDITOR.htmlParser.text) {
								buf.push(child.value);
							}
							else if (child instanceof CKEDITOR.htmlParser.element) {
								stringify(child, buf);
							}
							else if (child instanceof CKEDITOR.htmlParser.cdata) {
							}
							else if (child instanceof CKEDITOR.htmlParser.comment) {
							}
							else
								throw new Error('type: ' + child);
						}

					}

					// Put al tekstindhold i foerste element.
					const firstchild = e.children[0];
					const item = liststyle === 'ol' ? '1. ' : '- ';
					const buf: string[] = [item];
					stringify(e, buf);

					// Fjern alle andre end det foerste.
					for (let i = e.children.length - 1; i > 0; i--) {
						const child = e.children[i];
						child.remove();
					}

					const textval = buf.join('');
					// Ryd indhold af foerste element, og indsaet teksten deri.
					if (firstchild instanceof CKEDITOR.htmlParser.element) {
						for (let i = 0; i < firstchild.children.length; i++) {
							const child = firstchild.children[i];
							child.remove();
						}
						firstchild.children.push(new CKEDITOR.htmlParser.text(textval));
					}
					else if (firstchild instanceof CKEDITOR.htmlParser.text) {
						firstchild.value = textval;
					}
					else
						throw new Error('firstchild er ikke element eller text: ' + firstchild);
				}
			}
			else if (child instanceof CKEDITOR.htmlParser.element) {
				if (e instanceof CKEDITOR.htmlParser.element ||
					e instanceof CKEDITOR.htmlParser.fragment)
					ancestors.push(e);
				cleanShit(child, ancestors);
				if (e instanceof CKEDITOR.htmlParser.element ||
					e instanceof CKEDITOR.htmlParser.fragment)
					ancestors.pop();
			}
		}
	}

	{
		let dumpfoer = '';
		if (debuglog) {
			dumpfoer = DumpFragment(fragment);
			console.debug(`fixedparent e, enable=${enable}, foer:\n`, dumpfoer);
		}

		cleanShit(fragment, []);

		if (debuglog) {
			const dumpefter = DumpFragment(fragment);
			console.debug('fixedparent e, efter:\r', dumpefter === dumpfoer ? "(samme som foer)" : dumpefter);
		}
	}

	function dumpit() { DumpFragment(42 as any) }

	function DumpFragment(e: CKEDITOR.htmlParser.fragment | CKEDITOR.htmlParser.node) {
		if (e instanceof CKEDITOR.htmlParser.fragment || e instanceof CKEDITOR.htmlParser.element) {
			const buf: string[] = [];
			DumpFragmentImpl(e, '', buf);
			return buf.join('\r\n');
		}
		else if (e instanceof CKEDITOR.htmlParser.text) {
			return '#text: ' + e.value;
		} else {
			throw new Error('notimpl: ' + e);
		}
	}

	function DumpFragmentImpl(
		e: CKEDITOR.htmlParser.node | CKEDITOR.htmlParser.fragment,
		indent: string,
		buf: string[]
	) {
		if (e instanceof CKEDITOR.htmlParser.element) {
			buf.push(indent + e.name);
			for (const att in e.attributes) {
				buf.push(indent + ' .' + att + ': ' + e.attributes[att]);
			}
			for (const c of e.children) {
				DumpFragmentImpl(c, indent + '\t', buf);
			}
		} else if (e instanceof CKEDITOR.htmlParser.fragment) {
			buf.push(indent + '#fragment');
			for (const c of e.children) {
				if (!(
					c instanceof CKEDITOR.htmlParser.fragment ||
					c instanceof CKEDITOR.htmlParser.element ||
					c instanceof CKEDITOR.htmlParser.text ||
					c instanceof CKEDITOR.htmlParser.comment)) {
					throw new Error('uventet');
				}
				DumpFragmentImpl(c, indent + '\t', buf);
			}
		} else if (e instanceof CKEDITOR.htmlParser.text) {
			buf.push(indent + 'text: ' + e.value);
		} else if (e instanceof CKEDITOR.htmlParser.comment) {
			buf.push(indent + 'comment: ' + e.value);
		} else if (e instanceof CKEDITOR.htmlParser.node) {
			throw new Error('dumpfragment: uventet nodetype: node.');
		} else {
			const x: never = e;
			throw new Error('dumpfragment: uventet nodetype: ' + e);
		}
	}


	const writer = new CKEDITOR.htmlParser.basicWriter();
	fragment.writeHtml(writer);
	const markupAfter = writer.getHtml(false);
	return markupAfter;
}
